import WarrantyState from "slices/warranty/warranty-interface";

const warrantyInitialState: WarrantyState = {
  warrantyInfo: {
    allWarranties: [],
    defaultWarranties: [],
    recordsLength: 0,
  },
};

export default warrantyInitialState;
